/**
 * Yvine Design — background music (header button, data-art="music").
 *
 * Owner's rule: play automatically whenever the browser allows it; whenever it
 * doesn't, ASK — every time. Browsers refuse to start sound before the visitor
 * has interacted with the page, so "autoplay" means: straight away when the
 * browser already allows it (later pages of a visit), otherwise the bubble
 * ("Play some music?" on the first visit, "Continue the music?" after that)
 * and the first tap / click / key press anywhere starts it. Only "No thanks"
 * or the header button switch it off — that choice is kept in localStorage
 * and nothing plays or asks again until the button is pressed.
 *
 * Loading never competes with the page: the clip (assets/motion-loop.m4a,
 * ~1.2 MB) is fetched at low priority after the load event, in idle time, and
 * not at all on data-saver / 2G connections until the visitor asks for it.
 * Playback goes through Web Audio so the loop is gapless (the file's seam is
 * crossfaded) and fades in / out. The header survives the in-place page swaps,
 * so the music carries on while browsing.
 */
Art.section('music', function (btn) {
  var KEY = 'art_music'; // 'off' = the visitor switched it off; anything else = wanted
  var VOL = 0.55, FADE_IN = 2.0, FADE_OUT = 0.8;
  var src = btn.getAttribute('data-src');
  var ctx, gain, node, buffer, loading, fallback, silent;

  // iOS: Web Audio counts as "ambient" sound and is muted by the ring/silent
  // switch, while <audio> elements are not. A playing (silent) media element
  // moves the audio session to playback mode, so the music comes through
  // regardless of the switch. Started on the same tap as the music.
  var SILENCE = 'data:audio/wav;base64,UklGRoQJAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YWAJAACAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIA=';
  function unlock() {
    if (!silent) {
      silent = document.createElement('audio');
      silent.setAttribute('playsinline', '');
      silent.setAttribute('webkit-playsinline', '');
      silent.loop = true;
      silent.preload = 'auto';
      silent.src = SILENCE;
    }
    var p = silent.play();
    if (p && p.catch) p.catch(function () {});
  }
  function relock() { if (silent) silent.pause(); }

  // Plain <audio> fallback when Web Audio can't decode / start on this device.
  function fallbackPlay() {
    if (!fallback) {
      fallback = document.createElement('audio');
      fallback.setAttribute('playsinline', '');
      fallback.setAttribute('webkit-playsinline', '');
      fallback.loop = true;
      fallback.preload = 'auto';
      fallback.src = src;
    }
    fallback.volume = VOL;
    var p = fallback.play();
    if (p && p.catch) p.catch(function () { show(false); });
  }

  function wanted() { try { return localStorage.getItem(KEY) !== 'off'; } catch (e) { return true; } }
  function remember(on) { try { if (on) localStorage.removeItem(KEY); else localStorage.setItem(KEY, 'off'); } catch (e) {} }
  function show(on) { btn.setAttribute('aria-pressed', on ? 'true' : 'false'); }

  function context() {
    if (ctx) return ctx;
    var AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
    gain = ctx.createGain();
    gain.gain.value = 0;
    gain.connect(ctx.destination);
    return ctx;
  }

  function slowNetwork() {
    var c = navigator.connection;
    return !!(c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')));
  }

  // Fetch + decode once; low priority so it never delays page content.
  function load() {
    if (buffer) return Promise.resolve(buffer);
    if (!loading) {
      var opts = { credentials: 'same-origin' };
      try { opts.priority = 'low'; } catch (e) {}
      loading = fetch(src, opts)
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.arrayBuffer(); })
        .then(function (ab) { return new Promise(function (res, rej) { context().decodeAudioData(ab, res, rej); }); })
        .then(function (b) { buffer = b; return b; })
        .catch(function (err) { loading = null; throw err; });
    }
    return loading;
  }
  function prefetch() {
    if (buffer || loading || slowNetwork() || !wanted() || !context()) return;
    var idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 800); };
    idle(function () { load().catch(function () {}); });
  }

  function play() {
    if (!context() || node || !buffer) return;
    node = ctx.createBufferSource();
    node.buffer = buffer;
    node.loop = true;
    node.connect(gain);
    var t = ctx.currentTime;
    gain.gain.cancelScheduledValues(t);
    gain.gain.setValueAtTime(0, t);
    gain.gain.linearRampToValueAtTime(VOL, t + FADE_IN);
    node.start();
  }

  // Must be called from a user gesture (or when the browser already allows sound).
  function start() {
    show(true);
    unlock();
    if (!context()) { fallbackPlay(); return; }
    var go = function () {
      if (ctx.state !== 'running') { show(false); relock(); arm(); return; } // still blocked: wait for a gesture
      btn.classList.add('is-loading');
      load().then(function () { btn.classList.remove('is-loading'); if (btn.getAttribute('aria-pressed') === 'true') play(); })
        .catch(function () { btn.classList.remove('is-loading'); if (btn.getAttribute('aria-pressed') === 'true') fallbackPlay(); });
    };
    if (ctx.state === 'running') go(); else ctx.resume().then(go, go);
  }

  function stop() {
    show(false);
    relock();
    if (fallback) fallback.pause();
    if (!ctx || !node) return;
    var n = node; node = null;
    var t = ctx.currentTime;
    gain.gain.cancelScheduledValues(t);
    gain.gain.setValueAtTime(gain.gain.value, t);
    gain.gain.linearRampToValueAtTime(0, t + FADE_OUT);
    n.stop(t + FADE_OUT);
  }

  // First interaction anywhere (not the button itself — its own handler runs).
  // touchend / click / keydown only: iOS grants sound for those, not for the
  // touch-down, and an early rejected attempt would waste the gesture.
  var armed = false;
  var events = ['touchend', 'click', 'keydown'];
  function onFirst(e) {
    if (btn.contains(e.target) || (ask && ask.contains(e.target))) return;
    disarm(); askDone();
    if (wanted()) start();
  }
  function arm() { if (armed) return; armed = true; events.forEach(function (ev) { document.addEventListener(ev, onFirst, { passive: true, capture: true }); }); }
  function disarm() { if (!armed) return; armed = false; events.forEach(function (ev) { document.removeEventListener(ev, onFirst, { capture: true }); }); }

  btn.addEventListener('click', function () {
    disarm(); askDone();
    if (btn.getAttribute('aria-pressed') === 'true') { remember(false); stop(); }
    else { remember(true); start(); }
  });

  // A small prompt next to the button whenever the music can't start on its
  // own. "Play" is the gesture the browser needs; "No thanks" is remembered.
  var ASKED = 'art_music_asked';
  var ask = btn.parentElement && btn.parentElement.querySelector('[data-music-ask]');
  function askDone() { if (ask) ask.hidden = true; try { localStorage.setItem(ASKED, '1'); } catch (e) {} }
  // First visit: "Play some music?". Later loads where the music is wanted
  // but the browser won't resume it without a tap (Brave, iOS): "Continue the
  // music?" — same bubble, one tap on Play is the gesture it needs.
  function maybeAsk() {
    if (!ask || !wanted()) return;
    var asked = false;
    try { asked = !!localStorage.getItem(ASKED); } catch (e) {}
    if (asked) {
      var t = ask.querySelector('.art-header__music-ask-text');
      if (t && ask.getAttribute('data-resume')) t.textContent = ask.getAttribute('data-resume');
    }
    setTimeout(function () {
      if (btn.getAttribute('aria-pressed') === 'true') return; // already playing (first tap happened / auto-resumed)
      ask.hidden = false;
    }, asked ? 500 : 1200);
  }
  if (ask) {
    ask.querySelector('[data-music-yes]').addEventListener('click', function () { disarm(); askDone(); remember(true); start(); });
    ask.querySelector('[data-music-no]').addEventListener('click', function () { disarm(); askDone(); remember(false); stop(); });
  }

  show(false);
  if (wanted()) {
    // Later pages in the visit: the browser may already allow sound → just go.
    // Otherwise wait for a tap and offer the bubble so the tap is an easy one.
    // The first tap starts it from the very first moment; the check whether
    // the browser would allow sound without one waits until the page has
    // loaded and gone idle, because creating the audio engine costs a few
    // hundred ms of main thread on a phone — time the first paint needs.
    arm();
    var decide = function () {
      if (btn.getAttribute('aria-pressed') === 'true') return; // a tap already started it
      if (context() && ctx.state === 'running') { disarm(); start(); } else maybeAsk();
    };
    var idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 300); };
    var afterLoad = function () { idle(decide, { timeout: 1500 }); };
    if (document.readyState === 'complete') afterLoad(); else window.addEventListener('load', afterLoad);
    // The clip (about 1 MB) waits for the visitor's first sign of life — a
    // tap, a key, a scroll — instead of downloading while the page itself is
    // still arriving. The first tap is also what starts the sound, so it is
    // fetched exactly when it is about to be wanted.
    var soon = function () {
      ['pointerdown', 'keydown', 'touchstart', 'scroll', 'wheel'].forEach(function (t) {
        window.removeEventListener(t, soon, true);
      });
      prefetch();
    };
    ['pointerdown', 'keydown', 'touchstart', 'scroll', 'wheel'].forEach(function (t) {
      window.addEventListener(t, soon, { capture: true, passive: true });
    });
  }
});
